import { cn } from '@/lib/utils'

import { LoadingGraphics } from './loading-graphics'

export const ProgressGuide = () => {
  return (
    <div
      className={cn(
        'flex flex-col items-center',
        'w-fit',
        'px-[15%] py-[30px]',
        'mx-auto',
        'rounded-[10px] border border-slate-300',
        'bg-white'
      )}
    >
      <LoadingGraphics />
      <p className={cn('mt-[30px]', 'text-center text-lg font-semibold text-black')}>
        Thanks for your patience while we complete the review of your documents.
      </p>
    </div>
  )
}
